// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__XAuy8"};